import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b1de62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { class: "window" }
const _hoisted_4 = { class: "main-body" }
const _hoisted_5 = {
  key: 0,
  class: "right-body1"
}
const _hoisted_6 = {
  key: 1,
  class: "right-body2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.store.state.items.length === 0 || $setup.isLoading.value == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode($setup["Navigation"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode($setup["SideMenu"])
        ]),
        ($setup.store.getters.showPage != 'SubMenu')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ($setup.store.getters.showPage == '/')
                ? (_openBlock(), _createBlock($setup["NewsAndFAQ"], { key: 0 }))
                : ($setup.store.getters.showPage == 'StationCodeForSystemList')
                  ? (_openBlock(), _createBlock($setup["StationCodeForSystemList"], { key: 1 }))
                  : ($setup.store.getters.showPage == 'StationCodeList')
                    ? (_openBlock(), _createBlock($setup["StationCodeList"], { key: 2 }))
                    : ($setup.store.getters.showPage == 'BatchControl')
                      ? (_openBlock(), _createBlock($setup["StationCodeForSystemRegistration"], { key: 3 }))
                      : ($setup.store.getters.showPage == 'StationCodeRegistration')
                        ? (_openBlock(), _createBlock($setup["StationCodeRegistration"], { key: 4 }))
                        : ($setup.store.getters.showPage == 'FAQEdit')
                          ? (_openBlock(), _createBlock($setup["FAQEdit"], { key: 5 }))
                          : ($setup.store.getters.showPage == 'ManualEdit')
                            ? (_openBlock(), _createBlock($setup["ManualEdit"], { key: 6 }))
                            : ($setup.store.getters.showPage == 'CategoryEdit')
                              ? (_openBlock(), _createBlock($setup["CategoryEdit"], { key: 7 }))
                              : ($setup.store.getters.showPage == 'UserApproval')
                                ? (_openBlock(), _createBlock($setup["UserApproval"], { key: 8 }))
                                : ($setup.store.getters.showPage == 'PermissionsApproval')
                                  ? (_openBlock(), _createBlock($setup["PermissionsApproval"], { key: 9 }))
                                  : ($setup.store.getters.showPage == 'UserInquiryByDestination')
                                    ? (_openBlock(), _createBlock($setup["UserInquiryByDestination"], { key: 10 }))
                                    : ($setup.store.getters.showPage == 'UserInquiryByUserID')
                                      ? (_openBlock(), _createBlock($setup["UserInquiryByUserID"], { key: 11 }))
                                      : ($setup.store.getters.showPage == 'NewsEdit')
                                        ? (_openBlock(), _createBlock($setup["NewsEdit"], { key: 12 }))
                                        : ($setup.store.getters.showPage == 'NewsAdminEdit')
                                          ? (_openBlock(), _createBlock($setup["NewsAdminEdit"], { key: 13 }))
                                          : ($setup.store.getters.showPage == 'UserMaintenance')
                                            ? (_openBlock(), _createBlock($setup["UserMaintenance"], { key: 14 }))
                                            : ($setup.store.getters.showPage == 'UserInformation')
                                              ? (_openBlock(), _createBlock($setup["UserInformation"], { key: 15 }))
                                              : ($setup.store.getters.showPage == 'DistAdminList')
                                                ? (_openBlock(), _createBlock($setup["DistAdminList"], { key: 16 }))
                                                : ($setup.store.getters.showPage == 'DistAdminRegisteration')
                                                  ? (_openBlock(), _createBlock($setup["DistAdminRegisteration"], { key: 17 }))
                                                  : ($setup.store.getters.showPage == 'PwdResetRequest')
                                                    ? (_openBlock(), _createBlock($setup["PwdResetRequest"], { key: 18 }))
                                                    : ($setup.store.getters.showPage == 'MenuInquiry')
                                                      ? (_openBlock(), _createBlock($setup["MenuPermissionInquiry"], { key: 19 }))
                                                      : ($setup.store.getters.showPage == 'groupAdmin')
                                                        ? (_openBlock(), _createBlock($setup["GroupAdminList"], { key: 20 }))
                                                        : ($setup.store.getters.showPage == 'GroupAdminRegisteration')
                                                          ? (_openBlock(), _createBlock($setup["GroupAdminRegisteration"], { key: 21 }))
                                                          : ($setup.store.getters.showPage == 'MenuApprovalHistory')
                                                            ? (_openBlock(), _createBlock($setup["MenuApprovalHistory"], { key: 22 }))
                                                            : ($setup.store.getters.showPage == 'NewsMailMaintenance')
                                                              ? (_openBlock(), _createBlock($setup["NewsMailMaintenance"], { key: 23 }))
                                                              : ($setup.store.getters.showPage == 'LoginAdminMaintenance')
                                                                ? (_openBlock(), _createBlock($setup["LoginAdminMaintenance"], { key: 24 }))
                                                                : ($setup.store.getters.showPage == 'TechnicalDocument')
                                                                  ? (_openBlock(), _createBlock($setup["TechnicalDocument"], { key: 25 }))
                                                                  : ($setup.store.getters.showPage == 'CategoryDocumentMaintenance')
                                                                    ? (_openBlock(), _createBlock($setup["CategoryDocumentMaintenance"], { key: 26 }))
                                                                    : ($setup.store.getters.showPage == 'ConnectedRetailData')
                                                                      ? (_openBlock(), _createBlock($setup["RetailDataMaintenance"], { key: 27 }))
                                                                      : ($setup.store.getters.showPage == 'MenuStationMappingMaintenance')
                                                                        ? (_openBlock(), _createBlock($setup["MenuStationMappingMaintenance"], { key: 28 }))
                                                                        : ($setup.store.getters.showPage == 'WarrantyClaim')
                                                                          ? (_openBlock(), _createBlock($setup["WarrantyClaim"], { key: 29 }))
                                                                          : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode($setup["SubMenuList"])
            ]))
      ])
    ])
  ]))
}